<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>运营管理</a-breadcrumb-item>
    <a-breadcrumb-item> 星图端原生任务数据</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <!-- 日期范围： -->
    <span class="tool-title">日期范围：</span>
    <a-range-picker v-model:value="dateRangeModel" :format="dateFormat" />
    <!-- 任务类型： -->
    <span class="tool-title">任务类型：</span>
    <a-select v-model:value="taskTypeModel" style="width: 160px;" placeholder="请选择">
      <a-select-option :value="1">达人任务</a-select-option>
      <a-select-option :value="2">服务商任务</a-select-option>
    </a-select>
    <!-- 公司主体： -->
    <span class="tool-title">公司主体：</span>
    <a-select v-model:value="dysAccountIdModel" style="width: 160px;" placeholder="请选择">
      <a-select-option v-for="item in dysAccounts" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
    </a-select>
    <!-- 合并数据 -->
    <span class="tool-title">合并数据：</span>
    <a-select v-model:value="mergeTypeModel" style="width: 120px;" placeholder="请选择">
      <a-select-option :value="0">否</a-select-option>
      <a-select-option :value="1">是</a-select-option>
    </a-select>
    <!-- 操作 -->
    <a-button type="primary" style="margin-left: 16px;" @click="touchSearch">查询</a-button>
    <a-button style="margin-left: 16px; margin-right: 16px;" @click="touchReset">重置</a-button>
    <!-- 弹簧 -->
    <div style="flex: 1;"></div>
    <!-- 操作 -->
    <a-button @click="touchDownload">导出数据</a-button>
  </div>
  <!-- 列表 -->
  <a-table class="table-view" :data-source="dataSource" :columns="columns" :row-key="record => record.id"
    :pagination="false" :loading="isLoading" @change="handleTableChange">
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <template
        v-if="column.key === 'iaa_amount' || column.key === 'iaa_amount_estimated' || column.key === 'iaa_bill' || column.key === 'iap_amount' || column.key === 'iap_bill' || column.key === 'iap_amount_estimated'">
        {{ record[column.key] === '-' ? '-' : $pub.KEEP_NUMBER_DECIMAL((record[column.key] || 0) / 100, 2, false,
          true) }}
      </template>
      <template v-else-if="column.key === 'task_type' && record.data_date !== '汇总'">
        {{ record[column.key] === 1 ? '达人任务' : '服务商任务' }}
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  <!-- 自定义分页器 -->
  <a-pagination v-if="dataSource.length" style="margin: 16px 0; text-align: right;" v-model:current="pagination.current"
    v-model:pageSize="pagination.pageSize" :total="pagination.total" :showSizeChanger="pagination.showSizeChanger"
    @change="handlePaginationChange" />
</template>
<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import * as Ex from "@netjoy/excelex"
import Pub from '@/utils/public'
import dayjs from 'dayjs'
import { dyxtTaskDataList, dysAccountAll } from '@/api/copyright'

// 更新时间
let refreshTime = ref('')
// 加载
let isLoading = ref(false)
// 任务类型
let taskTypeModel = ref(undefined)
let taskType = ref(undefined)
// 日期范围
const dateFormat = 'YYYY-MM-DD'
let dateRangeModel = ref([dayjs().subtract(32, 'day'), dayjs().subtract(2, 'day')])
let dateRange = ref([dayjs().subtract(32, 'day'), dayjs().subtract(2, 'day')])
// 合并数据
let mergeTypeModel = ref(0)
let mergeType = ref(0)
// 排序字段
let order = ref('iap_amount_estimated')
// 数据源
let dataSource = ref([])
// 公司主体列表
let dysAccounts = ref([])
// 公司主体
let dysAccountIdModel = ref(undefined)
let dysAccountId = ref(undefined)
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '日期',
    dataIndex: 'data_date',
    key: 'data_date'
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
  },
  {
    title: '任务ID',
    dataIndex: 'task_id',
    key: 'task_id'
  },
  {
    title: '公司主体',
    dataIndex: 'star_name',
    key: 'star_name'
  },
  {
    title: '任务类型',
    dataIndex: 'task_type',
    key: 'task_type'
  },
  {
    title: '预估付费流水',
    dataIndex: 'iap_amount_estimated',
    key: 'iap_amount_estimated',
    showSorterTooltip: false,
    sorter: true,
    sortDirections: ['descend'],
    defaultSortOrder: 'descend'
  },
  {
    title: '预估付费分佣金额',
    dataIndex: 'iap_bill',
    key: 'iap_bill'
  },
  {
    title: '已发放付费分佣',
    dataIndex: 'iap_amount',
    key: 'iap_amount',
  },
  {
    title: '预估广告流水',
    dataIndex: 'iaa_amount_estimated',
    key: 'iaa_amount_estimated',
    showSorterTooltip: false,
    sorter: true,
    sortDirections: ['descend'],
    defaultSortOrder: 'descend'
  },
  {
    title: '预估广告分成金额',
    dataIndex: 'iaa_bill',
    key: 'iaa_bill'
  },
  {
    title: '已发放广告分成',
    dataIndex: 'iaa_amount',
    key: 'iaa_amount'
  }
])

// 钩子函数
onBeforeMount(() => {
  // 初始化选择项列表
  getSelectList()
  // 获取推广数据列表
  getList()
})

// 分页处理
function handleTableChange(p, filters, sorter) {
  //  console.log(sorter)
  // 分页信息
  pagination.current = Number(p.current) || 1
  pagination.pageSize = Number(p.pageSize) || 10
  // 只处理排序字段
  if (sorter && sorter.field) {
    order.value = sorter.field
    // 排序时建议重置到第一页
    pagination.current = 1
  }
  getList()
}

// 分页处理
function handlePaginationChange(current, pageSize) {
  pagination.current = Number(current) || 1
  pagination.pageSize = Number(pageSize) || 10
  getList()
}

// 查询
function touchSearch() {
  // 调整参数
  taskType.value = taskTypeModel.value
  dateRange.value = dateRangeModel.value
  mergeType.value = mergeTypeModel.value
  dysAccountId.value = dysAccountIdModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset() {
  dateRangeModel.value = [dayjs().subtract(32, 'day'), dayjs().subtract(2, 'day')]
  mergeTypeModel.value = 0
  mergeType.value = 0
  taskTypeModel.value = undefined
  taskType.value = undefined
  dysAccountIdModel.value = undefined
  dysAccountId.value = undefined
  // 初始化获取
  touchSearch()
}

// 获取推广数据列表
function getList() {
  isLoading.value = true
  const params = {
    start_time: dateRange.value ? `${dateRange.value[0].format(dateFormat)}` : undefined,
    end_time: dateRange.value ? `${dateRange.value[1].format(dateFormat)}` : undefined,
    order: order.value, // 只传这个
    is_merge: mergeType.value,
    star_id: dysAccountId.value,
    page: pagination.current,
    page_size: pagination.pageSize,
    type: taskType.value
  }
  dyxtTaskDataList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      // console.log(data);
      // 处理汇总数据字段名
      let sum = data.sumarry || {}
      dataSource.value = data.data.concat([sum])
      pagination.total = Number(data.total) || 0
      refreshTime.value = data.refresh_time
    } else {
      message.error(res.message || msg)
    }
  })
}

// 初始化选择项列表
function getSelectList() {
  // dyAgentName().then(res => {
  //   const { code, data } = res
  //   if (code === 0) {
  //     termediarys.value = data
  //   }
  // })
  dysAccountAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      dysAccounts.value = data
    }
  })
}

// 点击导出数据
function touchDownload() {
  isLoading.value = true
  const params = {
    start_time: dateRange.value ? `${dateRange.value[0].format(dateFormat)}` : undefined,
    end_time: dateRange.value ? `${dateRange.value[1].format(dateFormat)}` : undefined,
    order: order.value,
    is_merge: mergeType.value,
    star_id: dysAccountId.value,
    page: 1,
    page_size: 100000,
    type: taskType.value
  }
  dyxtTaskDataList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      // 处理汇总数据字段名
      let sum = data.sumarry || {}
      const list = [].concat(data.data).concat([sum])
      if (list.length) {
        const columns = [
          {
            name: '日期',
            field: 'data_date'
          },
          {
            name: '任务名称',
            field: 'name'
          },
          {
            name: '公司主体',
            field: 'star_name'
          },
          {
            name: '任务ID',
            field: 'task_id'
          },
          {
            name: '任务类型',
            field: 'task_type'
          },
          {
            name: '预估付费流水',
            field: 'iap_amount_estimated'
          },
          {
            name: '预估付费分佣金额',
            field: 'iap_bill',
          },
          {
            name: '已发放付费分佣',
            field: 'iap_amount'
          },
          {
            name: '预估广告流水',
            field: 'iaa_amount_estimated'
          },
          {
            name: '预估广告分成金额',
            field: 'iaa_bill'
          },
          {
            name: '已发放广告分成',
            field: 'iaa_amount'
          }
        ]
        const sheets = [
          {
            data: list,
            columns: columns
          }
        ]
        Ex.ex(sheets, function (item, field, json, sheetIndex, row, col, rowCount, colCount) {
          // row=0 为表头
          if (row != 0) {
            // 金额处理
            if (field === 'iap_amount_estimated' || field === 'iap_bill' || field === 'iap_amount' || field === 'iaa_amount_estimated' || field === 'iaa_bill' || field === 'iaa_amount') {
              if (item.data != '-') {
                item.data = Pub.KEEP_NUMBER_DECIMAL(item.data / 100, 2, false, true)
              }
              return item
            }
            // 任务类型处理
            if (field === 'task_type') {
              item.data =
                item.data === 1
                  ? '达人任务'
                  : item.data === 2
                    ? '服务商任务'
                    : item.data || ''
              return item
            }
          }
          // 无数据兼容
          // item.data = item.data || 0
          return item
        }, `达人运营- 星图端原生任务数据`)
      } else {
        message.error('还没有可导出的内容')
      }
    } else {
      message.error('导出失败')
    }
  }).catch(() => {
    message.error('导出失败')
  })
}
</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.table-view {
  margin-top: 30px;
}

.tool-title:not(:first-child) {
  margin-left: 16px;
}

.alert-view {
  margin-top: 20px;
}

.break-span {
  word-break: break-all;
  word-wrap: break-word;
}

.list-view {
  position: relative;

  .list-hint {
    position: absolute;
    bottom: 14px;
  }
}

.ant-table-column-sorters .ant-tooltip {
  display: none !important;
}
</style>